<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="5 0 32 32"
    :fill="fill">
    <path d="M16 2.66675C10.84 2.66675 6.66663 6.84008 6.66663 12.0001C6.66663 19.0001 16 29.3334 16 29.3334C16 29.3334 25.3333 19.0001 25.3333 12.0001C25.3333 6.84008 21.16 2.66675 16 2.66675ZM9.33329 12.0001C9.33329 8.32008 12.32 5.33341 16 5.33341C19.68 5.33341 22.6666 8.32008 22.6666 12.0001C22.6666 15.8401 18.8266 21.5867 16 25.1734C13.2266 21.6134 9.33329 15.8001 9.33329 12.0001Z"/>
    <path d="M16 15.3334C17.8409 15.3334 19.3333 13.841 19.3333 12.0001C19.3333 10.1591 17.8409 8.66675 16 8.66675C14.159 8.66675 12.6666 10.1591 12.6666 12.0001C12.6666 13.841 14.159 15.3334 16 15.3334Z"/>
  </svg>
</template>

<script>
export default {
  name: "LocationIcon",
  props: {
    fill: {
      type: String,
      default: 'inherit'
    },
    size: {
      type: Number,
      default: 32
    }
  }
}
</script>
